import { extractTags } from "./propertyExtraction";
import { styleBySection } from "./util/stepSectionStyle";
import { classifyLmRestriction } from "./util/restrictionClass.mjs";
import { LM_WIDTHS, restrictionStyles } from "./util/restrictionStrokes";

// LM lane restrictions, in the same classes, colours and strokes as the RM/OSMLR
// Restrictions view (util/restrictionClass.mjs, util/restrictionStrokes.js) — only
// narrower, because LM lanes lie side by side.

export function getHDLaneRestrictionStyleNormal(feature) {
  return getHDLaneRestrictionStyle(feature);
}

export function getHDLaneRestrictionStyleClick(feature) {
  return getHDLaneRestrictionStyle(feature, true, false);
}

export function getHDLaneRestrictionStyleHover(feature) {
  return getHDLaneRestrictionStyle(feature, false, true);
}

// A lane with nothing to report: a grey hairline on a thin white edge.
const PLAIN = {
  strokes: [
    { color: "white", width: 2 },
    { color: "grey", width: 1 },
  ],
};

// `tags` holds scalar values only: where a tag is step-encoded, styleBySection() has
// already resolved it to the value that applies to the section being drawn (or
// undefined where no section covers it).
function getHDLaneRestrictionStyle(feature, click = false, hover = false) {
  const tags = extractTags(feature);
  if (
    tags.hdMap !== "lane_center_line" &&
    tags.hdMap !== "lane_trajectory_line"
  ) {
    // No style, not a transparent one: OL hit-tests a 0-width stroke at the canvas's
    // previous width, which made lane borders selectable.
    return [];
  }

  return styleBySection(
    feature,
    tags,
    classifyLmRestriction,
    (restriction, geometry) =>
      restrictionStyles(restriction, geometry, {
        plain: PLAIN,
        widths: LM_WIDTHS,
        click,
        hover,
      }),
  );
}
